const genQr = {
    id: `generate-qr-${Math.random()}`,
    title: 'Generate QR',
    type: 'item',
    url: `/admin/generate-qr`,
    breadcrumbs: false,
    role: process.env.REACT_APP_RL_ADMNGQRPW
};

export default genQr;